import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import MyList from '../../components/MyList';
import * as Api from '../../utils/api';
import { basePageWrap } from '../BasePage';
import styles from '../MyListPage/MyListPage.module.scss';

import Head from 'next/head';
import {
    countSavedItems,
    decodeIdsObject,
    getSavedIdsObject,
    MY_LIST_KEY_EVENT_OCCURRENCES,
    MY_LIST_KEY_GUIDES,
    MY_LIST_KEY_OBJECTS,
    removeSavedId,
} from '../../utils/MyListStorage';

const MyListPage = ({ title = '', tabs = [], shareLink }) => {
    const [items, setItems] = useState({});
    const [hasItems, setHasItems] = useState(null);

    const fixItems = (idCheck = true) => {
        let ids = shareLink ? decodeIdsObject(shareLink) : getSavedIdsObject();

        if (idCheck) {
            if (Object.values(ids).some((val) => val.length) === false) {
                setHasItems(false);
                return;
            }
            setHasItems(true);
        }

        let responseItems = {
            [MY_LIST_KEY_OBJECTS]: [],
            [MY_LIST_KEY_EVENT_OCCURRENCES]: [],
            [MY_LIST_KEY_GUIDES]: [],
        };

        Object.keys(ids).map((key) => {
            if (ids[key].length) {
                fetchData(key, ids[key])
                    .then((response) => {
                        responseItems = {
                            ...responseItems,
                            [key]: response,
                        };
                        setItems(responseItems);
                    })
                    .catch(async (e) => {
                        if (e.status === 400) {
                            const errorResponse = await e.json();

                            // If validation error on invalid/outdated ids, remove them and reload the page
                            if (errorResponse.ids) {
                                errorResponse.ids.map((error) => {
                                    const matchedIds = error.match(/\d+/);
                                    if (matchedIds) {
                                        matchedIds.map((id) =>
                                            removeSavedId(key, Number(id))
                                        );
                                    }
                                });
                                // if there is null values in storage, remove it
                                removeSavedId(key, null);
                                window.location.reload();
                            }
                        }
                    });
            }
        });
    };

    useEffect(() => {
        fixItems();

        window.addEventListener('myListUpdated', () => {
            fixItems(false);

            if (!countSavedItems()) {
                setHasItems(false);
            }
        });
    }, []);

    const fetchData = (key, ids) => {
        if (key === MY_LIST_KEY_GUIDES) {
            return Api.guidesApi.listGuidePages({ ids, size: 100 });
        } else if (key === MY_LIST_KEY_EVENT_OCCURRENCES) {
            return Api.eventsApi.listEventOccurrences({
                ids: ids.filter((x) => !!x),
                size: 100,
            });
        } else if (key === MY_LIST_KEY_OBJECTS) {
            return Api.objectsApi.listObjectPages({ ids, size: 100 });
        } else {
            throw new Error('Support for ' + key + ' is not implemented');
        }
    };

    const isShared = Boolean(shareLink);

    return (
        <>
            <Head>
                <link
                    rel="stylesheet"
                    href="/third-party-styling/leaflet/leafletoriginal.css"
                />
                <link
                    rel="stylesheet"
                    href="/third-party-styling/leaflet/leaflet.css"
                />
                <link
                    rel="stylesheet"
                    href="/third-party-styling/leaflet/leaflet-marker-cluster.css"
                />
            </Head>
            <div className={styles['MyListPage']}>
                <MyList
                    title={title}
                    hasItems={hasItems}
                    showRemoveButtons={!isShared}
                    items={items}
                    tabs={tabs}
                />
            </div>
        </>
    );
};

MyListPage.propTypes = {
    title: PropTypes.string,
    tabs: PropTypes.array,
};

export default basePageWrap(MyListPage);
